import type { CircleRadius } from '../useMapCircleRadius.types';
import { getRadiusFromBounds } from './get-radius-from-bounds';

/**
 * Gets the circle radius in miles, calculating it from bounds if not provided.
 * Returns undefined if neither radius nor bounds are available.
 */
export function getCircleRadius(
  circleRadius: CircleRadius,
): number | undefined {
  // If radius is provided, use it
  if (circleRadius.radiusInMiles !== undefined) {
    return circleRadius.radiusInMiles;
  }

  // If radius is not provided but bounds are available, calculate from bounds
  if (circleRadius.bounds) {
    return getRadiusFromBounds(
      circleRadius.centerLat,
      circleRadius.centerLng,
      circleRadius.bounds,
    );
  }

  // Neither radius nor bounds provided
  return undefined;
}
